import type { PropsWithChildren } from "react";

export const FooterWrapper = ({ children }: PropsWithChildren<any>) => (
  <div className="fixed bottom-4 sm:max-w-[12.25rem] md:max-w-[16.5rem]">
    {children}
  </div>
);
